import loginLayout from '../layouts/login'
import onboardingLayout from '../layouts/onboarding'
import builderLayout from '../layouts/builder'
import previewLayout from '../layouts/preview'
import interviewLayout from "../layouts/interview"
import JobUnavailableLayout from "../layouts/job-unavailable.vue"
import SearchJobs from "../pages/auto-apply/search-jobs.vue";

// auth pages
const LoginPage = () => import('../pages/auth/login')
const RegisterPage = () => import('../pages/auth/register')
const ForgotPasswordPage = () => import('../pages/auth/forgot-password')
const ResetPasswordPage = () => import('../pages/auth/reset-password')

// app pages
const OnboardingPage = () => import('../pages/onboarding')
const DashboardPage = () => import('../pages/dashboard')
const ResumesPage = () => import('../pages/resumes')
const ResumeExamplesPage = () => import('../pages/resume-examples.vue')
const CoverLettersPage = () => import('../pages/cover-letters')
const SettingsPage = () => import('../pages/settings')
const NetworkingToolPage = () => import('../pages/networking-tool')
const NetworkingToolFavoritesPage = () => import('../pages/networking-tool-favorites')
const ResumeToolPage = () => import('../pages/resume-tool')
const BuilderResume = () => import('../pages/builder-resume')
const BuilderCoverLetter = () => import('../pages/builder-cover-letter')
const HelpPage = () => import('../pages/help/index')
const HelpViewPage = () => import('../pages/help/view')
const Errors404Page = () => import('../pages/errors/404')
const ExtensionLogin = () => import('../pages/extension-login')
const ServicesTrackingPage = () => import('../pages/services-tracking')
const JobTrackerPage = () => import('../pages/job-tracker-page.vue')
const JobTrackerPageV2 = () => import('../pages/job-tracker-page-v2.vue')
const AutoApplyPage = () => import('../pages/auto-apply-dashboard')
const AutoApplyJobsPage = () => import("../pages/auto-apply-jobs-page")
const JobsTrackingDataManagementPage = () => import("../pages/jobs-tracker-management-page.vue")
const AdminView = () => import("../pages/groups-page")
const SubgroupsPage = () => import("../pages/subgroups-page")
const SubgroupTablePage = () => import("../pages/subgroup-table")
const CreateInterviewPage = () => import("../pages/interview-ai/create-interview-page")
const InterviewAiDashboard = () => import("../pages/interview-ai/dashboard")
const InterviewAiInterviews = () => import("../pages/interview-ai/interviews-page")
const InterviewAiInterview = () => import("../pages/interview-ai/interview-page")
const InterviewAiCompleteInterview = () => import("../pages/interview-ai/interview-complete-page")
const ParsePage = () => import('../pages/parse')
const SubscriptionPage = () => import("../pages/subscription");
const LearningHubCourses = () => import("../pages/learning-hub/online-courses.vue");
const CoursePage = () => import("../pages/learning-hub/course.vue");

// job board imports
// const JobBoardAiOnboarding = () => import("../pages/job-board/onboarding.vue")
// const JobBoardAiDashboard = () => import("../pages/job-board/dashboard.vue")
const JobBoardAiSearch = () => import("../pages/job-board/search-jobs.vue")
const JobBoardAiSaved = () => import("../pages/job-board/saved-jobs.vue")
const JobBoardAiUnavailableJob = () => import("../pages/job-board/job-unavailable.vue")
// const JobBoardAiDocuments = () => import("../pages/job-board/documents.vue")
const JobBoardAiAlerts = () => import("../pages/job-board/job-alerts.vue")

const AutoApplySearchHistory = () =>  import("../pages/auto-apply-search-history.vue");

const CommunityDashboard = () => import("../pages/community/dashboard.vue")
const CommunitySavedResumes = () => import("../pages/community/saved-resumes.vue")
const CommunityProfile = () => import("../pages/community/profile.vue")
const DocumentNotFoundPage = () => import("../pages/share/document-not-found.vue")

const routes = [
    {
        path: '/extension-login',
        name: 'extension-login',
        component: ExtensionLogin
    },

    // auth 
    {
        path: '/login',
        name: 'login',
        component: LoginPage,
        meta: { layout: loginLayout }
    },
    {
        path: '/parse',
        name: 'parse',
        component: ParsePage,
        meta: { layout: loginLayout }
    },
    {
        path: '/register',
        name: 'register',
        component: RegisterPage,
        meta: { layout: loginLayout }
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: ForgotPasswordPage,
        meta: { layout: loginLayout }
    },
    {
        path: '/reset-password/:token',
        name: 'reset-password',
        component: ResetPasswordPage,
        meta: { layout: loginLayout }
    },

    // onboarding 
    {
        path: '/onboarding',
        name: 'onboarding',
        component: OnboardingPage,
        meta: { requiresAuth: true, layout: onboardingLayout }
    },

    // dashboard 
    {
        path: '/',
        name: 'home',
        component: DashboardPage,
        meta: {
            requiresAuth: true,
            title: 'WonsultingAI',
            feature: 'resume_upload'
        },
    },

     // building resume 
    {
        path: '/resumes',
        name: 'resumes',
        component: ResumesPage,
        meta: {
            requiresAuth: true,
            title: 'ResumAI by Wonsulting',
            feature: 'resume_upload'
        },
    },
    {
        path: '/resume-tool',
        name: 'resume-tool',
        component: ResumeToolPage,
        meta: {
            requiresAuth: false,
            title: 'ResumAI by Wonsulting',
            feature: 'bullet_generation_tool'
        },
    },
    {
        path: '/resumes/not-found',
        name: 'resume-not-found',
        component: DocumentNotFoundPage,
        meta: {
            requiresAuth: false,
            title: 'Resume not found | Wonsulting',
            feature: 'resumes',
            isPreview: true,
            layout: loginLayout
        },
    },
    {
        path: '/resumes/examples',
        name: 'resume-examples',
        component: ResumeExamplesPage,
        meta: {
            requiresAuth: true,
            title: 'ResumAI by Wonsulting',
            feature: 'resume_examples',
            coverLetter: false
        },
    },
    {
        path: '/resume/:id?',
        name: 'resumes.edit',
        component: BuilderResume,
        meta: {
            requiresAuth: false,
            layout: builderLayout,
            title: 'ResumAI by Wonsulting',
            feature: 'bullet_generation_tool',
            coverLetter: false
        },
    },
    {
        path: '/resume/preview/:id?',
        name: 'resumes.preview',
        component: BuilderResume,
        meta: {
            requiresAuth: false,
            isPreview: true,
            layout: previewLayout,
            coverLetter: false
        },
    },

    // cover letter 
    {
        path: '/cover-letters',
        name: 'cover-letters.index',
        component: CoverLettersPage,
        meta: {
            requiresAuth: true,
            title: 'CoverLetterAI by Wonsulting',
            coverLetter: true,
            feature: 'cover_letter'
        },
    },
    {
        path: '/cover-letter/:id?',
        name: 'cover-letters.edit',
        component: BuilderCoverLetter,
        meta: {
            requiresAuth: true,
            layout: builderLayout,
            coverLetter: true,
            feature: 'cover_letter',
            title: 'CoverLetterAI by Wonsulting',
        },
    },
    {
        path: '/cover-letter/preview/:id?',
        name: 'cover-letters.preview',
        component: BuilderCoverLetter,
        meta: { requiresAuth: false, isPreview: true, layout: previewLayout, coverLetter: true, feature: 'cover_letter' },
    },

    // settings 
    {
        path: '/settings',
        name: 'settings',
        component: SettingsPage,
        meta: {
            requiresAuth: true,
            title: 'WonsultingAI'
        },
    },

    // subscription 
    {
        path: '/subscription',
        name: 'subscription',
        component: SubscriptionPage,
        meta: {
            requiresAuth: true,
            title: 'WonsultingAI Subscription'
        },
    },

    // service tracker 
    {
        path: '/services-tracker',
        name: 'services-tracker',
        component: ServicesTrackingPage,
        meta: {
            requiresAuth: true,
            title: 'Services Tracking by Wonsulting'
        }
    },

    // auto apply
    {
        path: '/auto-apply',
        name: 'auto-apply',
        component: AutoApplyPage,
        meta: {
            requiresAuth: true,
            title: 'AutoApplyAI by Wonsulting',
            feature: 'auto_apply'
        },
        props: true
    },
    {
        path: '/auto-apply/search-history',
        name: 'auto-apply-search-history',
        component: AutoApplySearchHistory,
        meta: {
            requiresAuth: true,
            title: 'AutoApplyAI by Wonsulting',
            feature: 'auto_apply'
        }
    },
       // job tracker 
    {
        path: '/job-tracker',
        name: 'job-tracker',
        component: JobTrackerPage,
        meta: {
            requiresAuth: true,
            title: 'JobTrackerAI by Wonsulting',
            feature: 'job_tracker'
        }
    },
    // {
    //     path: '/job-tracker-v2',
    //     name: 'job-tracker-v2',
    //     component: JobTrackerPageV2,
    //     meta: {
    //         requiresAuth: true,
    //         title: 'JobTrackerAI by Wonsulting',
    //         feature: 'job_tracker_v2'
    //     }
    // },
    {
        path: '/auto-apply/jobs',
        name: 'auto-apply-jobs',
        component: AutoApplyJobsPage,
        meta: {
            requiresAuth: true,
            title: 'AutoApplyAI by Wonsulting',
            feature: 'auto_apply'
        }
    },
    {
        path: '/auto-apply/search',
        name: 'auto-apply-search',
        component: SearchJobs,
        meta: {
            requiresAuth: true,
            title: 'AutoApplyAI by Wonsulting',
            feature: 'auto_apply'
        },
        props: true
    },
    {
        path: '/job-tracker/data-management',
        name: 'job-tracker-data-management',
        component: JobsTrackingDataManagementPage,
        meta: {
            requiresAuth: true,
            title: 'JobTrackerAI by Wonsulting',
            feature: 'job_tracker'
        }
    },

     // interview ai
    { 
        path: '/interview-ai',
        name: 'interview-ai',
        component: InterviewAiDashboard,
        meta: {
            requiresAuth: true,
            title: 'InterviewAI by Wonsulting',
            feature: 'interview'
        }
    },
    {
        path: '/interview-ai/interviews',
        name: 'interview-ai-interviews',
        component: InterviewAiInterviews,
        meta: {
            requiresAuth: true,
            title: 'InterviewAI by Wonsulting',
            feature: 'interview'
        }
    },
    {
        path: '/interview-ai/create',
        name: 'interview-ai-create',
        component: CreateInterviewPage,
        meta: {
            requiresAuth: true,
            title: 'InterviewAI by Wonsulting',
            feature: 'interview'
        }
    },
    {
        path: '/interview-ai/interview/:interviewId/round/:roundId',
        name: 'interview-ai-interview',
        component: InterviewAiInterview,
        meta: {
            requiresAuth: true,
            layout: interviewLayout,
            title: 'InterviewAI by Wonsulting',
            feature: 'interview'
        }
    },
    {
        path: '/interview-ai/complete',
        name: 'interview-ai-complete',
        component: InterviewAiCompleteInterview,
        meta: {
            requiresAuth: true,
            title: 'InterviewAI by Wonsulting',
            feature: 'interview'
        }
    },
    
    //networking tool
    {
        path: '/networking-tool',
        name: 'networking-tool',
        component: NetworkingToolPage,
        meta: {
            requiresAuth: true,
            title: 'NetworkAI by Wonsulting',
            feature: 'network_tool'
        },
    },
    {
        path: '/networking-tool/favorites',
        name: 'networking-tool-favorites',
        component: NetworkingToolFavoritesPage,
        meta: {
            requiresAuth: true,
            title: 'NetworkAI by Wonsulting',
            feature: 'network_tool'
        },
    },

    // job board
    // {
    //     path: '/job-board/onboarding',
    //     name: 'job-board-onboarding',
    //     component: JobBoardAiOnboarding,
    //     meta: {
    //         requiresAuth: true,
    //         title: 'JobBoardAI by Wonsulting',
    //         feature: 'job_board'
    //     },
    // },
    // {
    //     path: '/job-board',
    //     name: 'job-board',
    //     component: JobBoardAiDashboard,
    //     meta: {
    //         requiresAuth: true,
    //         title: 'JobBoardAI by Wonsulting',
    //         feature: 'job_board'
    //     },
    // },
    {
        path: '/job-board/search',
        name: 'job-board-search',
        component: JobBoardAiSearch,
        meta: {
            requiresAuth: false,
            title: 'JobBoardAI by Wonsulting',
            feature: 'job_board'
        },
    },
    {
        path: '/job-board/saved',
        name: 'job-board-saved',
        component: JobBoardAiSaved,
        meta: {
            requiresAuth: true,
            title: 'JobBoardAI by Wonsulting',
            feature: 'job_board'
        },
    },
    {
        path: '/job-board/job-unavailable',
        name: 'job-board-job-unavailable',
        component: JobBoardAiUnavailableJob,
        meta: {
            requiresAuth: true,
            title: 'JobBoardAI by Wonsulting',
            feature: 'job_board',
            layout: JobUnavailableLayout
        },
    },
    // {
    //     path: '/job-board/documents',
    //     name: 'job-board-documents',
    //     component: JobBoardAiDocuments,
    //     meta: {
    //         requiresAuth: true,
    //         title: 'JobBoardAI by Wonsulting',
    //         feature: 'job_board'
    //     },
    // },
    {
        path: '/job-board/job-alerts',
        name: 'job-board-alerts',
        component: JobBoardAiAlerts,
        meta: {
            requiresAuth: true,
            title: 'JobBoardAI by Wonsulting',
            feature: 'job_board'
        },
    },
    
    // community
    {
        path: '/community',
        name: 'community',
        component: CommunityDashboard,
        meta: {
            requiresAuth: false,
            title: 'Community | Wonsulting',
            feature: 'community',
            isPreview: true,
        },
    },
    {
        path: '/community/saved',
        name: 'community-saved',
        component: CommunitySavedResumes,
        meta: {
            requiresAuth: true,
            title: 'Community | Saved Resumes | Wonsulting',
            feature: 'community',
            isPreview: true,
        },
    },
    {
        path: '/community/profile',
        name: 'community-profile',
        component: CommunityProfile,
        meta: {
            requiresAuth: true,
            title: 'Community | My Profile | Wonsulting',
            feature: 'community',
            isPreview: true,
        },
    },
    // admin group tool
    {
        path: '/admin-view/groups',
        name: 'admin-view',
        component: AdminView,
        meta: {
            title: 'Admin View'
        },
    },
    {
        path: '/admin-view/groups/:groupId',
        name: 'admin-view-subgroups',
        component: SubgroupsPage,
        meta: {
            title: 'Admin View Subgroups'
        },
    },
    {
        path: '/admin-view/groups/:groupId/subgroups/:subgroupId',
        name: 'admin-view-subgroup-table',
        component: SubgroupTablePage,
        meta: {
            title: 'Admin View Subgroup'
        },
    },
    
    //learning hub start
    {
        path: '/learning-hub/courses',
        name: 'learning-hub-courses',
        component: LearningHubCourses,
        meta: {
            title: 'Learning Hub Courses'
        },
    },
    {
        path: '/learning-hub/course/:id',
        name: 'learning-hub-course',
        component: CoursePage,
        meta: {
            title: 'Learning Hub Course'
        },
    },
    
    // help routes
    {
        path: '/help',
        name: 'help',
        component: HelpPage,
        meta: {
            requiresAuth: true,
            title: 'WonsultingAI'
        },
    },
    {
        path: '/help/:slug',
        name: 'help.view',
        component: HelpViewPage,
        meta: { requiresAuth: true }
    },

    // not found routes
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        meta: { layout: loginLayout },
        component: Errors404Page,
    },
]

export default routes
